import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterNav = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
  padding: 2rem 1rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
`;

const FooterColumn = styled.div`
  min-width: 200px;
`;

const ColumnTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: 0.75rem;
  color: #ffffff;
`;

const FooterList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterItem = styled.li`
  margin-bottom: 0.5rem;

  a {
    color: #bdc3c7;
    text-decoration: none;
    font-size: 0.9rem;

    &:hover {
      color: #ffffff;
    }
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <FooterNav>
        <FooterColumn>
          <ColumnTitle>DUNS Number Basics</ColumnTitle>
          <FooterList>
            <FooterItem><Link to="/what-is-duns">What is a DUNS Number?</Link></FooterItem>
            <FooterItem><Link to="/how-to-get">How to Get a DUNS Number</Link></FooterItem>
            <FooterItem><Link to="/benefits">Benefits of a DUNS Number</Link></FooterItem>
            <FooterItem><Link to="/articles/duns-number-lookup-free">Free DUNS Lookup Methods</Link></FooterItem>
            <FooterItem><Link to="/articles/duns-vs-ein">DUNS vs EIN</Link></FooterItem>
          </FooterList>
        </FooterColumn>
        <FooterColumn>
          <ColumnTitle>Popular Guides</ColumnTitle>
          <FooterList>
            <FooterItem><Link to="/articles/duns-number-apple-developer">DUNS for Apple Developers</Link></FooterItem>
            <FooterItem><Link to="/articles/duns-for-google-app-developers">DUNS for Google Developers</Link></FooterItem>
            <FooterItem><Link to="/articles/duns-number-government-contracts">DUNS for Government Contracts</Link></FooterItem>
            <FooterItem><Link to="/articles/duns-number-business-credit">DUNS &amp; Business Credit</Link></FooterItem>
            <FooterItem><Link to="/all-articles">All Articles</Link></FooterItem>
          </FooterList>
        </FooterColumn>
        <FooterColumn>
          <ColumnTitle>Tools &amp; Resources</ColumnTitle>
          <FooterList>
            <FooterItem><Link to="/duns-lookup">Free DUNS Number Lookup</Link></FooterItem>
            <FooterItem><Link to="/countries">DUNS Number by Country</Link></FooterItem>
            <FooterItem><Link to="/about">About This Service</Link></FooterItem>
          </FooterList>
        </FooterColumn>
      </FooterNav>
      <div className="container">
        <div className="footer-content">
          <p>&copy; {currentYear} Global DUNS Number Finder. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
